export class ExpressionHelper {

  constructor(expression = null) {
    this.baseConditions = {
      playWhen: {
        label: 'Play When',
        value: 'playWhen',
      },
      playWhenNot: {
        label: 'Play When Not',
        value: 'playWhenNot'
      }
    }
    this.defaultRule = { operator: null, expressionKey: null, expressionValue: null }
    if (expression) {
      this.expression = JSON.parse(JSON.stringify(expression))
    } else {
      this.expression = {
        baseCondition: 'playWhen',
        rules: [{ ...this.defaultRule }]
      }
    }
  }

  getExpression() {
    return this.expression
  }

  getBaseConditions() {
    const baseConditions = []
    for(const k in this.baseConditions) {
      baseConditions.push(this.baseConditions[k])
    }
    return baseConditions
  }

  // Generates a string representation of the expression to show in the UI
  toString() {
    if (!this.expression || !this.expression.rules || !this.expression.rules.length) return
    const finalString = this.expression.rules.map((item, index) => {
      // Destructure relevant fields with fallbacks
      const operator = item.operator ? item.operator.key.toUpperCase() : ''
      const expressionKey = item.expressionKey ? item.expressionKey.text : ''
      const expressionValue = item.expressionValue ? item.expressionValue.text : ''
      // If selection not complete don't show text
      if (!expressionKey || !expressionValue) return
      // Construct the condition string
      let condition = ` ${expressionKey} = '${expressionValue}'`

      // Prepend the operator to conditions after the first one
      if (index > 0 && operator) {
        condition = ` ${operator} ${condition} `
      }

      return condition
    }).join(' ')

    return `${this.baseConditions[this.expression.baseCondition] && this.baseConditions[this.expression.baseCondition].label} (${finalString})`
  }

  // Adds a new rule to the expression (e.g., an AND/OR condition)
  updateBaseCondition(value) {
    this.expression.baseCondition = value
    return this.expression
  }

  // Adds a new rule to the expression (e.g., an AND/OR condition)
  addRule() {
    this.expression.rules.push({ ...this.defaultRule })
    return this.expression
  }

  removeRule(indexToRemove) {
    if (indexToRemove >= 0 && indexToRemove < this.expression.rules.length) {
      this.expression.rules.splice(indexToRemove, 1) // Remove the item at the valid index
    }
    return this.expression
  }

  getSelectedTagsAndCfs() {
    const selectedCustomFields = []
    const selectedTags = []

    // Ensure data is an array and iterate over it
    if (this.expression && Array.isArray(this.expression.rules)) {
      this.expression.rules.forEach((item) => {
        // Safely check for expressionKey and its properties
        const expressionKey = item.expressionKey || {}
        const expressionValue = item.expressionValue || {}

        // Check for selected custom fields (excluding 'tagsPartner')
        if (expressionKey.key && expressionKey.key !== 'tagsPartner' && expressionKey.text && expressionValue.text) {
          selectedCustomFields.push(expressionValue)
        }

        // Check for selected tags (where expressionKey is 'tagsPartner')
        if (expressionKey.key === 'tagsPartner' && expressionValue.key && expressionValue.text) {
          selectedTags.push(expressionValue) // Push the entire expressionValue object
        }
      })
    }

    return {
      selectedCustomFields,
      selectedTags
    }
  }

  getSaveableExpression() {
    const _expression = JSON.parse(JSON.stringify(this.expression))
    _expression.rules.map((x) => {
      if (x && x.expressionValueOptions) delete x.expressionValueOptions
      return x
    })
    return _expression
  }

  // Check if the expression is complete and valid
  isValidExpression() {
    const expression = this.expression.rules
    console.log('isValidExpression', expression, this.expression)
    if (!Array.isArray(expression) || expression.length === 0 || !this.expression.baseCondition) return false
    return expression.every((expression, index) =>
      index === 0
        ? expression.operator === null
        : expression.operator && expression.operator.key
    ) && expression.every(expression =>
      expression.expressionKey && expression.expressionKey.key && expression.expressionKey.text &&
      expression.expressionValue && expression.expressionValue.key && expression.expressionValue.text
    )
  }

  evaluateExpression(options) {
    const { cfs = {}, tags = [], expressionJson = {} } = options
    const { expression = [], baseCondition = '' } = expressionJson

    if (expression && expression.length === 0) return true

    let result = true

    expression.forEach((condition, index) => {
      const { operator, expressionKey, expressionValue } = condition

      const isTagCondition = expressionKey.key === 'tagsPartner'

      let isConditionMet = false

      if (isTagCondition) {
        isConditionMet = (tags && tags.length > 0) ? tags.includes(expressionValue.key) : false
      } else {
        isConditionMet = (cfs && cfs[expressionKey.key] && cfs[expressionKey.key].length > 0) ? cfs[expressionKey.key].includes(expressionValue.text) : false
      }
      // Handle the first condition without an operator
      if (index === 0) {
        result = isConditionMet
      } else if (operator && operator.key) {
        // Ensure the operator has a valid key
        switch (operator.key) {
        case 'and':
          result = result && isConditionMet
          break
        case 'or':
          result = result || isConditionMet
          break
        case 'and not':
          result = result && !isConditionMet
          break
        default:
          console.error(`Unsupported operator: ${operator.key} at index ${index}`)
          break
        }
      } else {
        console.error(`Missing operator in condition at index ${index}`)
      }
    })
    // Base condition --
    if (baseCondition) {
      if (baseCondition === 'playWhen') {
        result = (result === true) ? true : false
      } else if (baseCondition === 'playWhenNot') {
        result = (result === false) ? true : false
      }
    }
    return result
  }
}


// WEBPACK FOOTER //
// ./src/common/helpers/ExpressionHelper.js